/* eslint-disable */
import React from 'react'
import http from '../Interceptor/Interseptor'
import jMoment from 'moment-jalaali'
import {Checkbox, message} from 'antd'
import Select from 'react-select'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import $ from 'jquery'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SearchableCombo from '../BaseComponent/searchableCombo'
import AutoComplete from '../BaseComponent/autocomplete'

class ReportEditedPrerecord extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      wareHousesname: [],
      docType: [],
      errorForm: '',
      showTable: false,
      listWareHouse: [],
      preRecordInfo: {},
      urlQuery: '',
      providers: [],
      providerValue: '',
      selectedOption: [],
      wareType: [],
      report: [],
      fromDate: '',
      toDate: '',
      modalDelete: false,
      fromManual: '',
      toManual: '',
      printInfo: [],
      printFrom: '',
      printTo: '',
      buttonClicked: false,
      pageNumber: 1,
      pageSize: 10,
      countAll: 0,
      sortBy: 'created_desc',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ ویرایش',
          value: 'created',
          sorted: true,
          direction: null,
          sortable: true
        },

        {
          name: 'وضعیت بازگشت',
          value: 'rollBacked',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ بازگشت',
          value: 'rolledBackTime',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کاربر ثبت کننده',
          value: 'rollBackOperatorId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تامین کننده',
          value: 'providerId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'جزییات',
          value: 'rollBackOperatorId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'بازگشت',
          value: 'return',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      operators: [],
      roleBackOperators: [],
      operatorId: '',
      rollBackOperatorId: ''
    }
  }

  getValueProvider = (providerId) => {
    if (providerId === null) {
      this.setState({
        providerId: []
      })
    } else {
      this.setState({
        providerId
      })
    }
  }

  submitForm(e) {
    e.preventDefault()
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    http.get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {}).then((response) => {
      if (response.data.error === null) {
        var operators = response.data.object
        for (let i = 0; i < operators.length; i++) {
          operators[i]['value'] = operators[i].personId
          operators[i]['label'] = operators[i].personId + ' - ' + operators[i].name
        }
        this.setState({
          operators: response.data.object,
          roleBackOperators: response.data.object
        })
      }
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  getReport = (exportStatus) => {
    this.setState({
      loading: true
    })
    let filter = this.createFilter(exportStatus)
    http
      .get(`invoices/edition/get`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            report: response.data.object.result,
            printFrom: this.state.fromDate == '' ? ' - ' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
            printTo: this.state.toDate == '' ? ' - ' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
            buttonClicked: true,
            loading: false,
            lengthList: response.data.object.countAll
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            listWareHouse: [],
            lengthList: 0,
            loading: false
          })
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
        this.setState({
          loading: false
        })
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    let providerId = this.state.providerId

    let editionMin = this.state.fromDate
    let editionMax = this.state.toDate
    let rolledBack = document.getElementById('rolledBack').value
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (editionMin !== '') {
      filter.editionMin = editionMin
    }

    if (this.state.operatorId !== '') {
      filter.operatorId = this.state.operatorId.personId
    }
    if (this.state.rollBackOperatorId !== '') {
      filter.rollBackOperatorId = this.state.rollBackOperatorId.personId
    }

    if (editionMax !== '') {
      filter.editionMax = editionMax
    }
    if (rolledBack !== '') {
      filter.rolledBack = rolledBack
    }
    if (providerId !== '') {
      filter.providerId = providerId
    }

    return filter
  }

  getValueOperator = (operatorId) => {
    if (operatorId === null) {
      this.setState({
        operatorId: ''
      })
    } else {
      this.setState({
        operatorId
      })
    }
  }
  getValueRoleBackOperator = (rollBackOperatorId) => {
    if (rollBackOperatorId === null) {
      this.setState({
        rollBackOperatorId: ''
      })
    } else {
      this.setState({
        rollBackOperatorId
      })
    }
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })
    let filter = this.createFilter(true)

    http
      .get(`invoices/edition/get`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable,.print').fadeIn()

          this.setState({
            printInfo: response.data.object.result,
            lengthList: response.data.object.countAll,
            loading: false
          })
        } else {
          this.setState({
            printInfo: [],
            loading: false
          })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`invoices/edition/get`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let excelReport = this.state.excelReport
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i].created = jMoment(excelReport[i].created)
            if (excelReport[i].rolledBackTime !== null) {
              excelReport[i].rolledBackTime = jMoment(excelReport[i].rolledBackTime)
            }
            if (excelReport[i].rollBacked) {
              excelReport[i].rollBacked = 'بازگشت شده'
            } else {
              excelReport[i].rollBacked = 'بازگشت نشده'
            }
          }

          this._export.save(excelReport)
        }
      })
  }

  roleBack = (masterId) => {
    this.setState({
      modalRoleBack: true,
      masterId
    })
  }
  roleBackOk = () => {
    let {masterId} = this.state
    http.patch(`invoices/edition/rollback/${masterId}`, {}).then((res) => {
      if (res.data.error === null) {
        this.setState({
          modalRoleBack: false,
          masterId: ''
        })
        this.getReport(false)
        message.success('با موفقیت انجام شد')
      } else {
        message.error(res.data.description)
      }
    })
  }

  render() {
    const {loading} = this.state
    let {pageNumber, pageSize} = this.state
    let name = cookie.load('name')
    let columns = ['ردیف', 'تاریخ ویرایش', 'وضعیت', 'تاریخ بازگشت', 'کاربر بازگشت کننده']

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش فاکتورهای ویرایش شده"
              headerColSpan={5}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={2}
              rightColSpan={2}
              centerColSpan={1}
              centerSection={''}
              rightSection={'تاریخ از ' + this.state.printFrom + ' تا ' + this.state.printTo}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.created !== null && jMoment(item.created).format('jYYYY/jM/jDD HH:mm')}</td>
                  <td>
                    {item.rollBacked ? (
                      <img
                        style={{width: 30, height: 30}}
                        title="بازگشت داده شده"
                        src={require('../../image/confirm.svg')}
                      />
                    ) : (
                      <img
                        src={require('../../image/ignor.svg')}
                        title="بازگشت داده نشده"
                        style={{width: 30, height: 30}}
                      />
                    )}
                  </td>
                  <td>{item.rolledBackTime !== null && jMoment(item.rolledBackTime).format('jYYYY/jM/jDD HH:mm')}</td>
                  <td>{item.rollBackOperatorId}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            ref={(exporter) => {
              this._export = exporter
            }}
            dir="rtl"
            fileName="گزارش ویرایش فاکتورهای انجام شده.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'created'}
                field={'created'}
                title={'تاریخ ویرایش'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'rollBacked'}
                field={'rollBacked'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'rolledBackTime'}
                field={'rolledBackTime'}
                title={'تاریخ بازگشت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'rollBackOperatorId'}
                field={'rollBackOperatorId'}
                title={'کاربر بازگشت کننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>ویرایش فاکتورها</li>
            <li>مشاهده ویرایش های انجام شده</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ از"
                  toLabel="تاریخ تا"
                  fromId="from"
                  toId="to"
                  defaulValue
                />

                <div className="formComponent">
                  <label>وضعیت : </label>
                  <select className="form-control" id="rolledBack">
                    <option value="">------</option>
                    <option value={true}>بازگشت داده شده</option>
                    <option value={false}>بازگشت داده نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.operators}
                    getValueCombo={this.getValueOperator}
                    lableText="کاربر ویرایش کننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    className="font-weight-bold"
                  />
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.roleBackOperators}
                    getValueCombo={this.getValueRoleBackOperator}
                    lableText="کاربر بازگشت دهنده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    className="font-weight-bold"
                  />
                </div>

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.report.map((item, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{item.created !== null && jMoment(item.created).format('jYYYY/jM/jDD HH:mm')}</td>
                      <td>
                        {item.rollBacked ? (
                          <img title="بازگشت داده شده" src={require('../../image/confirm.svg')} />
                        ) : (
                          <img src={require('../../image/ignor.svg')} title="بازگشت داده نشده" />
                        )}
                      </td>
                      <td>
                        {item.rolledBackTime !== null && jMoment(item.rolledBackTime).format('jYYYY/jM/jDD HH:mm')}
                      </td>
                      <td>{item.operatorFistName + ' ' + item.operatorLastName}</td>
                      <td>{item.providerName}</td>
                      <td>
                        <Link
                          to={`/showDetails/edited/invoice/${item.id}?createDate=${jMoment(item.created).format(
                            'jYYYY/jM/jDD HH:mm'
                          )}&rolledBackTime=${
                            item.rolledBackTime !== null
                              ? jMoment(item.rolledBackTime).format('jYYYY/jM/jDD HH:mm')
                              : ''
                          }`}
                          target="_blank"
                        >
                          <img src={require('../../image/eye.svg')} alt="" />
                        </Link>
                      </td>
                      <td>
                        {item.rolledBackTime === null && (
                          <button onClick={() => this.roleBack(item.id)}>
                            <img src={require('../../image/return.svg')} />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthList}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.modalRoleBack} toggle={() => this.setState({modalRoleBack: false})} size="md">
          <ModalHeader toggle={() => this.setState({modalRoleBack: false})}>بازگشت</ModalHeader>
          <ModalBody>
            <p className="titleSm">
              <Checkbox
                className="form-check"
                name="confirmCheck"
                checked={this.state.confirmCheck}
                onChange={() => this.setState({confirmCheck: !this.state.confirmCheck})}
              >
                آیا از بازگشت این فاکتور مطمئن هستید؟
              </Checkbox>
            </p>
          </ModalBody>
          <ModalFooter>
            <button
              disabled={this.state.confirmCheck ? false : true}
              className="confirmBtnModal"
              onClick={this.roleBackOk}
            >
              تایید نهایی
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({modalRoleBack: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default ReportEditedPrerecord
